import {StyleSheet} from 'react-native';
import { Colors } from '../../constants/Colors';

export const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
    backgroundColor: 'white',
    paddingHorizontal: 20,
    paddingVertical: 30,
  },
  containerAlert: {
    marginTop: 20,
  },
  containerList: {
    marginTop: 0,
    marginBottom: 20,
  },
  sugestedContainer: {
    marginBottom: 240,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  spaceSummary: {
    paddingHorizontal: 5,
    
    height: 50,
  },
  containerSummary: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  summaryText: {
    fontSize: 16,
    lineHeight: 16,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: 'black',
  },
  quantityText: {
    fontSize: 16,
    lineHeight: 16,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: 'black',
  },
  containerSubtotal: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  subtotalText: {
    fontSize: 16,
    lineHeight: 16,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: 'black',
  },
  priceText: {
    fontSize: 16,
    lineHeight: 16,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: 'black',
  },
  containerTotal: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  totalText: {
    fontSize: 16,
    lineHeight: 16,
    fontFamily: 'TCCC-UnityText Bold',
    color: 'black',
  },
  totalPrice: {
    fontSize: 16,
    lineHeight: 16,
    fontFamily: 'TCCC-UnityText Bold',
    color: 'black',
  },
  containerButton: {
    alignSelf: 'center',
    width: '80%',
    marginBottom: 100,
    marginTop: 20,
  },
     extendedTermsCard: {
      width: '100%',
      gap: 10,
      backgroundColor: '#f0f0f0',
      borderRadius: 8,
      paddingHorizontal: 8,
      paddingVertical: 10,
      marginTop: 5,
      marginBottom: 20,
      alignItems: 'center',
      justifyContent: 'center',
      borderWidth: 1,
      borderColor: '#ddd',
      minHeight: 20, // Adicione uma altura mínima para garantir espaço
    },
  extendedTermsCardText: {
    fontSize: 14, // Tamanho da fonte
    color: '#333', // Cor do texto
    textAlign: 'center', // Centraliza o texto
  },
  highlightedText: {
    color: Colors.RedPallete.red,
    fontWeight: '600', // Semibold
  },
    progressContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  checkIcon: {
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: Colors.RedPallete.red,
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkIconText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
  },
});
